import { FC, memo, useMemo } from "react";
import { Table, TableColumn } from "@vilocnv/allsetra-core";
import { STATIONARY_DATE_RENDERING } from "app/data/constants";
import { useTranslation } from "react-i18next";
import StationaryFinalData from "../StationaryFinalData/StationaryFinalData";

interface StationaryDateExpandableProps {
  data: any;
}

const StationaryDateExpandable: FC<StationaryDateExpandableProps> = ({
  data
}) => {
  const { t } = useTranslation(["translation", "tableHeadingsTranslation"]);

  const columns: TableColumn<any>[] = useMemo(
    () => STATIONARY_DATE_RENDERING(t),
    [t]
  );

  return (
    <Table
      columns={columns}
      data={data.records}
      expandableRows
      expandOnRowClicked
      expandableRowsComponent={StationaryFinalData}
      pagination={false}
      noTableHead={true}
      nestedRowPadding={"16px"}
      translator={t}
    />
  );
};

export default memo(StationaryDateExpandable);
